"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSliderTrack = void 0;
var _SliderTrack = require("./SliderTrack");
// TODO: in v9, move styled() from SliderTrack.jsx to here
var StyledSliderTrack = _SliderTrack.SliderTrack;
exports.StyledSliderTrack = StyledSliderTrack;